const getUnitFromArbitraryClass = (className: string): string | null => {
  // Regular expression to capture units in Tailwind class syntax
  const regex = /-\[([\d.]+)([a-zA-Z%]+)\]/;
  const match = className.match(regex);

  // Return the unit if found
  return match ? match[2] : null;
}

export default getUnitFromArbitraryClass;